import {
  Validate,
  IsDateString,
  ValidatorConstraint,
  ValidatorConstraintInterface,
  ValidationArguments,
} from 'class-validator';

@ValidatorConstraint({ name: 'isBefore', async: false })
class IsBefore implements ValidatorConstraintInterface {
  validate(propertyValue: string, args: ValidationArguments) {
    return new Date(propertyValue) < new Date((args.object as any)[args.constraints[0]]);
  }

  defaultMessage(args: ValidationArguments) {
    return `"${args.property}" must be before "${args.constraints[0]}"`;
  }
}

export class DatePicker {
  constructor(props: Partial<DatePicker>) {
    Object.assign(this, props);
  }

  @Validate(IsBefore, ['createdTo'])
  @IsDateString()
  createdFrom!: string;

  @IsDateString()
  createdTo!: string;
}
